import { SOURCE_ID_TYPE_URL } from 'Constants/index'
import { regexUrl } from 'Helpers/regexHelpers'
import { useIntl } from 'react-intl'
import { useRecoilState, useSetRecoilState } from 'recoil'

import {
  Badge,
  BADGE_KIND_OUTLINE,
  BADGE_TYPE_INFO,
  Flex,
  FormElement,
  Grid,
  GridCell,
  INPUT_TEXT_VARIANT_DANGER,
  InputText,
  Panel,
  SPACING_24,
  SPACING_8,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'

import { modalSharedListsState } from 'Pages/SourceEdit/recoil/state/modals'
import { isDirtyState, sourceState } from 'Pages/SourceEdit/recoil/state/source'

const BoxSetSource = () => {
  const intl = useIntl()

  const [
    {
      name,
      url,
      urlDisabled,
      isShared,
      idSource,
      sharedLists,
      selectAll,
      blockedLists,
      idType
    },
    setSource
  ] = useRecoilState(sourceState)
  const [{ isNameDirty, isUrlDirty }, setDirty] = useRecoilState(isDirtyState)
  const setModalShared = useSetRecoilState(modalSharedListsState)

  const onChangeName = ({ target: { value } }) => {
    setSource((prev) => ({ ...prev, name: value }))
    setDirty((prev) => ({ ...prev, isNameDirty: true }))
  }

  const onChangeUrl = ({ target: { value } }) => {
    setSource((prev) => ({ ...prev, url: value }))
    setDirty((prev) => ({ ...prev, isUrlDirty: true }))
  }

  const onClickBadge = () => {
    setModalShared((prev) => ({
      ...prev,
      show: true,
      sharedLists: Array.from(new Set(sharedLists.concat(blockedLists))),
      selectAll,
      blockedLists
    }))
  }

  return (
    <>
      <Title variant={TITLE_VARIANT_M}>
        {intl.formatMessage({ id: 'Load.ContentsSouces.SetSource' })}
      </Title>
      <SpacingVertical variant={SPACING_8} />
      <Panel>
        <Grid cols={12}>
          <GridCell span={isShared ? 9 : 12}>
            <Flex
              justifyContent='space-between'
              width='100%'
              margin='0 0 4px 0'
            >
              <Text variant={TEXT_VARIANT_BOLD}>
                {intl.formatMessage({
                  id: 'Load.ContentsSouces.SourceName'
                })}
                {' *'}
              </Text>
              {idSource > 0 && (
                <Text variant={TEXT_VARIANT_LIGHT}>
                  {intl.formatMessage({ id: 'Load.MailupCommon.Id' })}{' '}
                  {idSource}
                </Text>
              )}
            </Flex>
            <FormElement
              feedback={
                !name.trim() && isNameDirty
                  ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                  : null
              }
              feedbackVariant={!name.trim() && isNameDirty ? 'danger' : null}
            >
              <InputText
                onChange={onChangeName}
                value={name}
                data-mu-test='source__input-name'
                variant={
                  !name.trim() && isNameDirty ? INPUT_TEXT_VARIANT_DANGER : null
                }
              />
            </FormElement>
            {idType === SOURCE_ID_TYPE_URL && (
              <>
                <SpacingVertical variant={SPACING_24} />
                <FormElement
                  label={intl.formatMessage({
                    id: 'Load.ContentsSouces.UrlFeed'
                  })}
                  required
                  feedback={
                    !regexUrl.test(url) && isUrlDirty
                      ? intl.formatMessage({ id: 'Load.Common.InvalidUrl' })
                      : null
                  }
                  feedbackVariant={
                    !regexUrl.test(url) && isUrlDirty ? 'danger' : null
                  }
                >
                  <InputText
                    placeholder={intl.formatMessage({
                      id: 'Load.Common.UrlPlaceholder'
                    })}
                    onChange={onChangeUrl}
                    value={url}
                    data-mu-test='source__input-url'
                    variant={
                      !regexUrl.test(url) && isUrlDirty
                        ? INPUT_TEXT_VARIANT_DANGER
                        : null
                    }
                    disabled={urlDisabled}
                  />
                </FormElement>
              </>
            )}
          </GridCell>
          {isShared && (
            <GridCell span={3}>
              <Flex width='100%' justifyContent='flex-end'>
                <Badge
                  kind={BADGE_KIND_OUTLINE}
                  type={BADGE_TYPE_INFO}
                  onClick={onClickBadge}
                  text={intl.formatMessage({
                    id: 'Load.ContentsSouces.SharedSource'
                  })}
                  classIcon='icon-sli icon-share-3'
                />
              </Flex>
            </GridCell>
          )}
        </Grid>
      </Panel>
    </>
  )
}

export default BoxSetSource
